import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, connect } from 'react-redux';
import {
  fetchEligibiltyRequest,
  processEligibilityReportRequest,
} from '../../containers/clients/eligibility-redux/actions';
type props = {
  handleEligibilityFileViewModel: (id: number, type: string) => void;
  eligibilityId: number;
  eligibility?: any;
  eligibilityValidationData?: any;
  tableType: any;
  processEligibilityReport: any;
  processEligibilityReportError: any;
  clientId: any;
};
const EligibilityFileViewModel: React.FunctionComponent<props> = (props): JSX.Element => {
  const dispatch = useDispatch();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [existingMemberCount, setExistingMemberCount] = useState<number>(0);
  const [newMemberCount, setNewMemberCount] = useState<number>(0);
  const [removedMemberCount, setRemovedMemberCount] = useState<number>(0);
  const [invalidRecordCount, setInvalidRecordCount] = useState<number>(0);
  const [eligibilityList, setEligibilityList] = useState<any>([]);
  useEffect(() => {
    if (props.eligibilityId) {
      const input = {
        clientId: props.clientId,
        eligibilityId: props.eligibilityId,
      };
      dispatch(fetchEligibiltyRequest(input));
    }
  }, [props.eligibilityId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.tableType === 'historical') {
      const input = {
        clientId: props.clientId,
        eligibilityId: props.eligibilityId,
      };
      dispatch(processEligibilityReportRequest(input));
    }
  }, [props.tableType]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.eligibility?.data?.validation_report) {
      setTotalRecords(props.eligibility.data.validation_report.record_count);
      setExistingMemberCount(props.eligibility.data.validation_report.existing_members?.length);
      setNewMemberCount(props.eligibility.data.validation_report.members_to_add?.length);
      setRemovedMemberCount(props.eligibility.data.validation_report.members_to_remove?.length);
      setInvalidRecordCount(props.eligibility.data.validation_report.invalid_records?.length);
      let finalArray: any = [];
      props.eligibility.data.validation_report.members_to_add?.map((item: any) => {
        return finalArray.push({
          memberId: '',
          email: item,
          status: 'successful',
          message: 'New member',
        });
      });
      props.eligibility.data.validation_report.existing_members?.map((item: any) => {
        return finalArray.push({
          memberId: '',
          email: item,
          status: 'successful',
          message: 'existing member',
        });
      });
      props.eligibility.data.validation_report.members_to_remove?.map((item: any) => {
        return finalArray.push({
          memberId: '',
          email: item,
          status: 'successful',
          message: 'removing member',
        });
      });
      props.eligibility.data.validation_report.invalid_records?.map((item: any) => {
        return finalArray.push({
          memberId: item.member_id,
          email: item.email_address,
          status: 'unsuccessful',
          message: item.package_id,
        });
      });
      setEligibilityList(finalArray);
    }
  }, [props.eligibility]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (Object.keys(props.eligibilityValidationData)?.length) {
      setTotalRecords(props.eligibilityValidationData.record_count);
      setExistingMemberCount(props.eligibilityValidationData.existing_members.length);
      setNewMemberCount(props.eligibilityValidationData.members_to_add.length);
      setRemovedMemberCount(props.eligibilityValidationData.members_to_remove.length);
      setInvalidRecordCount(props.eligibilityValidationData.invalid_records.length);
      let finalArray: any = [];
      props.eligibilityValidationData.members_to_add.map((item: any) => {
        return finalArray.push({
          memberId: '',
          email: item,
          status: 'successful',
          message: 'New member',
        });
      });
      props.eligibilityValidationData.existing_members.map((item: any) => {
        return finalArray.push({
          memberId: '',
          email: item,
          status: 'successful',
          message: 'existing member',
        });
      });
      props.eligibilityValidationData.members_to_remove.map((item: any) => {
        return finalArray.push({
          memberId: '',
          email: item,
          status: 'successful',
          message: 'removing member',
        });
      });
      props.eligibilityValidationData.invalid_records.map((item: any) => {
        return finalArray.push({
          memberId: item.member_id,
          email: item.email_address,
          status: 'unsuccessful',
          message: item.package_id,
        });
      });
      setEligibilityList(finalArray);
    }
  }, [props.eligibilityValidationData]);

  return (
    <>
      <div className="z-100 fixed inset-0 flex items-center justify-center overflow-x-hidden outline-none focus:outline-none">
        <div className="w-5xl min-w-3xl max-h-182.5 relative mx-auto my-6 w-auto overflow-y-auto rounded-lg">
          <div className="relative flex w-full flex-col border-0 bg-white shadow-lg outline-none focus:outline-none">
            <div className="flex items-start justify-between">
              <div className="blue-primary px-10 pt-10 text-2xl">
                Process report for{' '}
                {props.tableType === 'historical' && moment(props.eligibility?.data?.completed_at).format('YYYY-MM-DD')}
              </div>
            </div>
            <div className="relative flex-auto px-10 pt-2">
              <p className="text-gray-dark h-full text-base text-sm font-normal leading-relaxed">Report Summary:</p>
              <p className="flex items-center">
                <p className="bg-gray-dark mr-2 h-3 w-3 rounded-full"></p>
                Total Records: {totalRecords}
              </p>
              <p className="flex items-center">
                <p className="bg-gray-dark mr-2 h-3 w-3 rounded-full"></p>
                Existing Members: {existingMemberCount}
              </p>
              <p className="flex items-center">
                <p className="bg-gray-dark mr-2 h-3 w-3 rounded-full"></p>
                New Members: {newMemberCount}
              </p>
              <p className="flex items-center">
                <p className="bg-gray-dark mr-2 h-3 w-3 rounded-full"></p>
                Members to Remove: {removedMemberCount}
              </p>
              <p className="flex items-center">
                <p className="bg-gray-dark mr-2 h-3 w-3 rounded-full"></p>
                Invalid Records: {invalidRecordCount}
              </p>
              <p className="flex items-center">
                <p className="bg-gray-dark mr-2 h-3 w-3 rounded-full"></p>
                Invalid Headers: {props.eligibilityValidationData?.headers_errors?.length}
              </p>
            </div>
            <div>
              {props.eligibilityValidationData?.headers_errors?.length > 0 && (
                <div className="px-10 pt-2">
                  <p className="h-full text-base text-sm font-normal leading-relaxed text-red-600">Header Errors:</p>
                  <ul className="list-inside list-disc">
                    {props.eligibilityValidationData.headers_errors.map((error: string, index: number) => (
                      <li key={index} className="text-sm text-red-600">
                        {error}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className="blue-primary px-10 pt-2 text-2xl">Process Details:</div>
            <table className="table-row-format relative mx-10 my-2 table-fixed border-collapse" key={Math.random()}>
              <thead className="h-full bg-white">
                <tr className="w-full px-7 text-left">
                  {props.tableType === 'historical' ? (
                    <>
                      <th>Title</th>
                      <th>Message</th>
                    </>
                  ) : (
                    <>
                      <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-1 text-base font-normal">
                        MemberId
                      </th>
                      <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                        Email
                      </th>
                      <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                        Status
                      </th>
                      <th className="text-gray-dark sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2 text-base font-normal">
                        Message
                      </th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {props.tableType !== 'historical' &&
                  eligibilityList?.length &&
                  eligibilityList.map((item: any, index: any) => {
                    return (
                      <tr className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left">
                        <td className="text-gray-dark text-bold border-bottom w-2/12 py-1 text-base font-bold">
                          {item.memberId}
                        </td>
                        <td className="border-bottom w-2/12 py-1">
                          <div className="flex">
                            <p className="text-gray-dark text-bold pr-2 text-base font-bold">{item.email}</p>
                          </div>
                        </td>
                        <td className="border-bottom w-2/12 py-1">
                          <div className="flex">
                            <p className="text-gray-dark text-bold pr-2 text-base font-bold">{item.status}</p>
                          </div>
                        </td>
                        <td className="border-bottom w-2/12 py-1">
                          <div className="flex">
                            <p className="text-gray-dark text-bold pr-2 text-base font-bold">{item.message}</p>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                {props.tableType === 'historical' &&
                  props.processEligibilityReport?.data?.length > 0 &&
                  props.processEligibilityReport.data.map((item: any, index: number) => {
                    if (item.event_name !== 'processing_summary') {
                      return (
                        <tr
                          className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left"
                          key={Math.random()}
                        >
                          <td className="border-bottom py-1">{item.event_name}</td>
                          <td>{item.message}</td>
                        </tr>
                      );
                    }
                    return false;
                  })}
              </tbody>
            </table>
            <div className="flex items-center justify-center pb-6">
              <button
                className="bg-gray-light text-cente rounded-full px-7 py-2 text-sm text-white"
                type="button"
                onClick={() => props.handleEligibilityFileViewModel(props.eligibilityId, '')}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    eligibility: state.eligibility.eligibilitySingle,
    processEligibilityReport: state.eligibility.processEligibilityReport,
    processEligibilityReportError: state.eligibility.processEligibilityReportError,
    pending: state.eligibility.pending,
  };
};

export default connect(mapStateToProps)(EligibilityFileViewModel);
